import RefreshTokenService from '@/services/refreshTokenService';
import { routingProcess } from '@/helpers/routeHelper';
import { decodeJwtTokenPayload } from '@/helpers/jwtHelper';
import store from '@/state/store';

const TOKEN_REFRESH_TIME = parseInt(process.env.VUE_APP_TOKEN_REFRESH_TIME) || 960; // saniye
const EARLY_REFRESH_THRESHOLD = parseInt(process.env.VUE_APP_EARLY_REFRESH_THRESHOLD) || 60; // token expire'a bu kadar saniye kala erken yenile

let intervalId = null;
const refreshTokenService = new RefreshTokenService();

export const state = {
  remaining: TOKEN_REFRESH_TIME,
  isRunning: false,
};

export const getters = {
  isRunning: (state) => state.isRunning,
  remaining: (state) => state.remaining,
};

export const mutations = {
  TICK(state) {
    state.remaining -= 1;
  },
  RESET(state) {
    state.remaining = TOKEN_REFRESH_TIME;
  },
  SET_RUNNING(state, value) {
    state.isRunning = value;
  },
};

export const actions = {
  start({ commit, state, dispatch }) {
    const token = localStorage.getItem('token');
    if (!token) return;
    if (state.isRunning) return;

    commit('SET_RUNNING', true);
    commit('RESET');

    intervalId = setInterval(() => {
      dispatch('tick');
    }, 1000);
  },

  stop({ commit }) {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    commit('SET_RUNNING', false);
    commit('RESET');
  },

  reset({ commit }) {
    commit('RESET');
  },

  async tick({ commit, state, dispatch }) {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch('stop');
      return;
    }

    // Bonus: Token'ın gerçek exp zamanını kontrol et (tab throttle / sleep koruması)
    try {
      const payload = decodeJwtTokenPayload(token);
      const expiresIn = (payload.exp * 1000 - Date.now()) / 1000;
      if (expiresIn <= EARLY_REFRESH_THRESHOLD) {
        await dispatch('doRefresh');
        return;
      }
    } catch {
      // Token decode edilemezse timer-based devam etsin
    }

    if (state.remaining > 0) {
      commit('TICK');
    } else {
      await dispatch('doRefresh');
    }
  },

  async doRefresh({ commit }) {
    try {
      const result = await refreshTokenService.refreshToken();
      const token = result?.data?.responseData;
      if (!token) return false;

      store.commit('auth/SET_TOKEN', token);
      await routingProcess();
      commit('RESET');
      return true;
    } catch {
      // Refresh başarısız — token geçersiz olmuş olabilir, bir sonraki API çağrısında 401 interceptor halledecek
      return false;
    }
  },
};
